<template>
  <div elevation="0">
    <div class="pa-3">
      <div class="title">Font Families</div>
      <div>
        You can choose a font pairing from defined font pairings. Changing fonts
        applies to all pages of your website.
      </div>
      <v-select
        :items="fontPairings"
        @change="onFontPairChange($event)"
        dense
        outlined
        :value="fontToId()"
        item-value="name"
        item-text="name"
        return-object
        class="mt-2"
        style="width: 300px"
      ></v-select>
      <v-btn
        small
        text
        color="primary"
        @click="selectCustomFont = !selectCustomFont"
        outlined
        style="width: 300px"
        class="mt-2"
        >Or Choose Yourself</v-btn
      >
      <div v-if="selectCustomFont">
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              dense
              outlined
              :items="googleFonts"
              v-model="selectedProject.siteTheme.fontFamily1"
              label="Heading font family"
              autocomplete="off"
              @change="
                UPDATE_PROJECT_PROP({
                  prop: ['siteTheme', 'fontFamily1'],
                  value: $event,
                });
                onInputSaveTheme();
              "
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              dense
              outlined
              :items="googleFonts"
              v-model="selectedProject.siteTheme.fontFamily2"
              label="Text font family"
              autocomplete="off"
              @change="
                UPDATE_PROJECT_PROP({
                  prop: ['siteTheme', 'fontFamily2'],
                  value: $event,
                });
                onInputSaveTheme();
              "
            ></v-autocomplete>
          </v-col>
        </v-row>
      </div>
      <div class="title">Text Sizes</div>
      <SliderInput
        label="Heading"
        :sliderValue="selectedProject.siteTheme.textSize.heading"
        min="0"
        max="60"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'textSize', 'heading'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
      <SliderInput
        label="Subheading"
        :sliderValue="selectedProject.siteTheme.textSize.subheading"
        min="0"
        max="60"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'textSize', 'subheading'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
      <SliderInput
        label="Text"
        :sliderValue="selectedProject.siteTheme.textSize.text"
        min="0"
        max="60"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'textSize', 'text'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
      <SliderInput
        label="Text"
        :sliderValue="selectedProject.siteTheme.textSize.text2"
        min="0"
        max="60"
        @change="
          UPDATE_PROJECT_PROP({
            prop: ['siteTheme', 'textSize', 'text2'],
            value: $event,
          });
          onInputSaveTheme();
        "
      />
    </div>
  </div>
</template>

<script>
import projectMixin from "./project-mixin";
import SliderInput from "../SliderInput";

function fontPair(heading, sub) {
  return {
    name: heading + " - " + sub,
    heading: heading,
    sub: sub,
  };
}

export const fontPairings = [
  fontPair("Playfair Display", "Roboto"),
  fontPair("Poppins", "Lato"),
  fontPair("Abril Fatface", "Montserrat"),
  fontPair("Sacramento", "Oswald"),
  fontPair("Paytone One", "Raleway"),
  fontPair("Dosis", "Lato"),
  fontPair("Yeseva One", "Roboto"),
  fontPair("Quicksand", "Nunito"),
  fontPair("Heebo", "Oswald"),
  fontPair("Libre Baskerville", "Lato"),
  fontPair("Nunito", "Raleway"),
  fontPair("Prata", "Montserrat"),
  fontPair("Cabin", "Open Sans"),
];

export default {
  mixins: [projectMixin],
  components: { SliderInput },
  data() {
    return {
      selectCustomFont: false,
      fontPairings,
    };
  },
  methods: {
    onFontPairChange(pair) {
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "fontFamily1"],
        value: pair.heading,
      });
      this.UPDATE_PROJECT_PROP({
        prop: ["siteTheme", "fontFamily2"],
        value: pair.sub,
      });
      this.onInputSaveTheme();
    },
    fontToId() {
      return (
        this.selectedProject.siteTheme.fontFamily1 +
        " - " +
        this.selectedProject.siteTheme.fontFamily2
      );
    },
  },
  async created() {
    await this.getGoogleFonts();
  },
};
</script>

<style scoped>
.button-theme {
  padding: 15px;
  display: flex;
  justify-content: center;
  border: 1px solid #efefef;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: 100ms all;
}
.button-theme:hover {
  border: 1px solid #cccccc;
}
</style>